import {
  Button as ChakraButton,
  ButtonProps as ChakraButtonProps,
} from "@chakra-ui/react";

export const Button = ({ children, ...props }: ChakraButtonProps) => (
  <ChakraButton
    variant="outline"
    bg="white"
    borderWidth="1px"
    borderColor="gray.300"
    color="gray.700"
    h="40px"
    borderRadius="8px"
    gap={2.5}
    pt={2.5}
    pr={3}
    pb={2.5}
    pl={3}
    opacity={1}
    fontFamily="Work Sans"
    fontWeight="500"
    fontSize="14px"
    lineHeight="19.2px"
    letterSpacing="0"
    verticalAlign="middle"
    boxShadow={"0 10px 15px 0 #F7F7F7"}
    {...props}
  >
    {children}
  </ChakraButton>
);
